import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiPlus, FiMinus } from "react-icons/fi";
import { faqs } from "../Data";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const FAQItem = ({ item, open, onClick }) => {
  return (
    <motion.div
      className={`faq-card ${open ? "active" : ""}`}
      variants={cardVariant}
      whileHover={{ y: -4 }}
      transition={{
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
    >
      <button className="faq-question" onClick={onClick}>
        <h3 className="card-heading">{item.question}</h3>
        <motion.div className="faq-icon">
          {open ? <FiMinus /> : <FiPlus />}
        </motion.div>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            className="faq-answer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            style={{ overflow: "hidden" }}
          >
            <motion.p
              className="section-text"
              initial={{ y: 10 }}
              animate={{ y: 0 }}
              exit={{ y: -10 }}
            >
              {item.answer}
            </motion.p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Separate FAQs into left and right columns (Odd/Even strategy)
  const leftFaqs = faqs.filter((_, idx) => idx % 2 === 0);
  const rightFaqs = faqs.filter((_, idx) => idx % 2 !== 0);

  return (
    <section className="faq-section">
      <div className="container">
        <motion.div
          className="heading-wrapper"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h2 className="section-heading">
            Quick answers to <span>common queries</span>
          </h2>
        </motion.div>

        <motion.div
          className="faq-grid"
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Left Column Container */}
          <div className="faq-column">
            {leftFaqs.map((item, index) => {
              const originalIndex = index * 2;
              return (
                <FAQItem
                  key={item.id || originalIndex}
                  item={item}
                  open={openIndex === originalIndex}
                  onClick={() =>
                    setOpenIndex(openIndex === originalIndex ? null : originalIndex)
                  }
                />
              );
            })}
          </div>

          {/* Right Column Container */}
          <div className="faq-column">
            {rightFaqs.map((item, index) => {
              const originalIndex = index * 2 + 1;
              return (
                <FAQItem
                  key={item.id || originalIndex}
                  item={item}
                  open={openIndex === originalIndex}
                  onClick={() =>
                    setOpenIndex(openIndex === originalIndex ? null : originalIndex)
                  }
                />
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Faqs;